module.exports = __webpack_public_path__ + "static/MK3T5115-9b66456d2ade935bd395c36439c963c1.jpg";